// State object
import axios from '../../axios-instance'

const initialState = () => ({
  currentSubscription: {
    data: {
      id: null,
      subscriptionNumber: ''
    },
    error: null
  },

  currentSubscriptionUnit: {
    id: null,
    alias: '',
    transientType: '',
    notes: '',
    transientFamily: '',
    serialNumber: ''
  },

  allUsers: { data: null, error: null }
})

const state = initialState()
// Getter functions
const getters = {
  UsersNotConnectedToSubscription: (state, getters, rootState) => {
    let allCustomerUsers = rootState.customer.allUsersWithSubscription.data
    let allSubscriptionUsers = state.allUsers.data
    if (allCustomerUsers === null && allSubscriptionUsers === null) {
      return []
    }
    if (allCustomerUsers.length > 0 && allSubscriptionUsers.length === 0) {
      return allCustomerUsers
    }

    let difference = JSON.parse(JSON.stringify(allCustomerUsers))
    for (let i in allSubscriptionUsers) {
      let index = difference.findIndex(function (item) {
        return item.id === allSubscriptionUsers[i].id
      })
      if (index >= 0) {
        difference.splice(index, 1)
      }
    }
    return difference
  }
}
// Mutations
const mutations = {
  setCurrentSubscription: function (state, subscription) {
    state.currentSubscription.data.id = subscription.data.id
    state.currentSubscription.data.subscriptionNumber = subscription.data.subscriptionNumber
    state.currentSubscription.error = subscription.error
  },
  setCurrentSubscriptionError: function (state, error) {
    state.currentSubscription.error = error
  },
  setCurrentSubscriptionUnit: function (state, unit) {
    if (unit.alias === undefined) {
      unit.alias = ''
    }
    if (unit.notes === undefined) {
      unit.notes = ''
    }
    state.currentSubscriptionUnit = unit
  },
  setCurrentSubscriptionAlias: function (state, alias) {
    state.currentSubscriptionUnit.alias = alias
  },
  setCurrentSubscriptionNotes: function (state, notes) {
    state.currentSubscriptionUnit.notes = notes
  },
  setAllUsers: function (state, users) {
    state.allUsers = users
  },
  setAllUsersError: function (state, error) {
    state.allUsers.error = error
  },

  removeUser: function (state, userId) {
    let index = state.allUsers.data.findIndex(function (item) {
      return userId === item.id
    })
    if (index >= 0) {
      state.allUsers.data.splice(index, 1)
    }
  },

  resetStates: function (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  }
}
// Actions
const actions = {
  /* -------FETCH-------- */
  fetchSubscription: function (context, subscriptionId) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/subscriptions/' + subscriptionId + '/useadministration'
      })
        .then(response => {
          context.commit('setCurrentSubscription', { data: response.data, error: null })
          context.commit('setCurrentSubscriptionUnit', response.data.unit)
          resolve()
        })
        .catch(error => {
          context.commit('setCurrentSubscriptionError', error.message)
        })
    })
  },
  fetchSubscriptionUsers: function (context, subscriptionId) {
    axios({
      method: 'get',
      url: '/subscriptions/' + subscriptionId + '/users'
    })
      .then(response => {
        context.commit('setAllUsers', { data: response.data, error: null })
      })
      .catch(error => {
        context.commit('setAllUsersError', error.message)
      })
  },

  /* -------SAVE(PUT/POST)-------- */
  saveUnitAlias: function (context, alias) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'patch',
        url: '/units/' + context.state.currentSubscriptionUnit.id + '/alias',
        data: {
          alias: alias
        }
      })
        .then(response => {
          context.commit('setSuccessMessage', 'Alias changed successfully', { root: true })
          context.dispatch('changeAlias', alias)
          resolve(response)
        })
        .catch(error => {
          reject(error.message)
        })
    })
  },

  savePriority: function (context, userId) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/subscriptions/' + context.state.currentSubscription.data.id + '/prioritizeduser',
        data: {
          userId: userId
        }
      })
        .then(response => {
          context.commit('setSuccessMessage', 'Priority changed successfully', { root: true })
          context.commit('setAllUsers', { data: response.data, error: null })
          resolve(response)
        })
        .catch(error => {
          context.commit('setErrorMessages', error.message, { root: true })
          reject(error.message)
        })
    })
  },

  saveUnitNotes: function (context, notes) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'patch',
        url: '/units/' + context.state.currentSubscriptionUnit.id + '/notes',
        data: {
          notes: notes
        }
      })
        .then(response => {
          context.commit('setSuccessMessage', 'Notes changed successfully', { root: true })
          context.dispatch('changeNotes', notes)
          resolve(response)
        })
        .catch(error => {
          reject(error.message)
        })
    })
  },

  /* -------DELETE-------- */
  removeSubscriptionAccess: function (context, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: '/subscriptions/' + payload.subscription.id + '/users/' + payload.user.id
      })
        .then(response => {
          resolve(payload)
        })
        .catch(error => {
          context.commit('setErrorMessages', error.message, { root: true })
          reject(error.message)
        })
    })
  },

  /* -------RESET-------- */
  resetCurrentSubscription: function (context) {
    context.commit('resetStates')
  },

  /* -------OTHER-------- */
  changeAlias: function (context, alias) {
    context.commit('setCurrentSubscriptionAlias', alias)
    const isCurrentSubscription = (subscription) => subscription.id === state.currentSubscription.data.id
    let index = context.rootState.customer.allSubscriptions.data.findIndex(isCurrentSubscription)

    if (index >= 0) {
      context.rootState.customer.allSubscriptions.data[index].unit.alias = alias
    }
  },

  changeNotes: function (context, notes) {
    context.commit('setCurrentSubscriptionNotes', notes)
    const isCurrentSubscription = (subscription) => subscription.id === state.currentSubscription.data.id
    let index = context.rootState.customer.allSubscriptions.data.findIndex(isCurrentSubscription)

    if (index >= 0) {
      context.rootState.customer.allSubscriptions.data[index].unit.notes = notes
    }
  },

  removeUsersFromSubscription: function (context, users) {
    for (let userId of users) {
      context.commit('removeUser', userId)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
